export { default as EnergyVisualizer } from './EnergyVisualizer';
export type { EnergyVisualizerProps } from './EnergyVisualizer';

/**
 * Generate a deterministic pseudo-random energy map from a seed string.
 * Useful as a fallback when no real energyMap data is available.
 */
export function generateFallbackEnergyMap(seed: string, length = 100): number[] {
  // Simple seeded hash function
  let hash = 0;
  for (let i = 0; i < seed.length; i++) {
    hash = ((hash << 5) - hash + seed.charCodeAt(i)) | 0;
  }

  const result: number[] = [];
  for (let i = 0; i < length; i++) {
    // xorshift-like pseudo-random from seed
    hash ^= hash << 13;
    hash ^= hash >> 17;
    hash ^= hash << 5;
    // Normalize to 0.15–1.0 range for visual appeal
    const normalized = (Math.abs(hash) % 1000) / 1000;
    result.push(0.15 + normalized * 0.85);
  }
  return result;
}
